import axios from 'axios'
/* eslint-disable */

export function slugify(string) {
    const a =
        'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b =
        'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

export function unslugify(slug) {
    const result = slug.replace(/\-/g, ' ')
    return result.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
}

export function flatten(a) {
    return Array.isArray(a) ? [].concat.apply([], a.map(flatten)) : a
}

export const getShuffledArray = (arr) => {
    const newArr = arr.slice()
    for (let i = newArr.length - 1; i > 0; i--) {
        const rand = Math.floor(Math.random() * (i + 1))
        ;[newArr[i], newArr[rand]] = [newArr[rand], newArr[i]]
    }
    return newArr
}

export const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()]
}

export function matchSortFirst(array, key, value) {
    const newArray = console.log('newArray, key, value', array, key, value)

    return newArray
}

export function groupBy(arr, property) {
    return arr.reduce(function (memo, x) {
        if (!memo[x[property]]) {
            memo[x[property]] = []
        }
        memo[x[property]].push(x)
        return memo
    }, {})
}

export const slugString = (slug) => {
    // prevent removing dashes from `one-piece`
    let op
    if (slug.match(/one-piece/)) {
        op = slug.match(/one-piece/)
    } else if (slug.match(/two-piece/)) {
        op = slug.match(/two-piece/)
    } else if (slug.match(/fleece-lined/)) {
        op = slug.match(/fleece-lined/)
    } else if (slug.match(/2-pack/)) {
        op = slug.match(/2-pack/)
    } else if (slug.match(/3-pack/)) {
        op = slug.match(/3-pack/)
    } else if (slug.match(/4-pack/)) {
        op = slug.match(/4-pack/)
    } else if (slug.match(/4-piece/)) {
        op = slug.match(/4-piece/)
    } else if (slug.match(/6-piece/)) {
        op = slug.match(/6-piece/)
    } else if (slug.match(/v-neck/)) {
        op = slug.match(/v-neck/)
    } else if (slug.match(/zip-up/)) {
        op = slug.match(/zip-up/)
    } else if (slug.match(/all-in-one/)) {
        op = slug.match(/all-in-one/)
    } else if (slug.match(/arms-out/)) {
        op = slug.match(/arms-out/)
    } else if (slug.match(/in-person/)) {
        op = slug.match(/in-person/)
    }

    let slugString

    if (op && op.length > 0) {
        let withoutOp
        if (
            op.toString() === '2-pack' ||
            op.toString() === '3-pack' ||
            op.toString() === '4-pack' ||
            op.toString() === '4-piece' ||
            op.toString() === '6-piece' ||
            op.toString() === 'zip-up' ||
            op.toString() === 'arms-out' ||
            op.toString() === 'v-neck' ||
            op.toString() === 'all-in-one' ||
            op.toString() === 'in-person'
        ) {
            withoutOp = slug.split(op)[1]
            // console.log('3-pack op, without op 3-pack', op, withoutOp)
            slugString = op + withoutOp.replace(/-/g, '%20')
        } else {
            op = op[0]
            withoutOp = slug.split(op)[0]
            // console.log('op, without op', op, withoutOp)
            slugString = withoutOp.replace(/-/g, '%20') + op
        }
    } else {
        slugString = slug.replace(/-/g, '%20')
    }

    return slugString
}


// export function sortFunc(a, b, sortingArr) {
//     return sortingArr.indexOf(a.size) - sortingArr.indexOf(b.size)
// }

export function sizeSortFunc(a, b) {
    let sortingArr = SIZES
    return (
        sortingArr.indexOf(a.initial_size) - sortingArr.indexOf(b.initial_size)
    )
}

export function patternSortFunc(a, b) {
    const sortArr = PATTERNS
    return sortArr.indexOf(a.initial_color) - sortArr.indexOf(b.initial_color)
}

export function mapOrder(array, myorder, key) {
    var order = myorder.reduce((r, k, i) => ((r[k] = i + 1), r), {})
    const sortedArray = array.sort(
        (a, b) => (order[a[key]] || Infinity) - (order[b[key]] || Infinity)
    )
    return sortedArray
}

export function insertUrlParam(key, value) {
    console.log('insertUrlParam', key, value)
    if (history.pushState) {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.set(key, value)
        let newurl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?' +
            searchParams.toString()
            console.log('newurl in insertUrlParam', newurl)
        window.history.pushState({ path: newurl }, '', newurl)
    }
}

export function floatSafeModulus(val, step) {
    var valDecCount = (val.toString().split('.')[1] || '').length
    var stepDecCount = (step.toString().split('.')[1] || '').length
    var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount
    var valInt = parseInt(val.toFixed(decCount).replace('.', ''))
    var stepInt = parseInt(step.toFixed(decCount).replace('.', ''))
    return (valInt % stepInt) / Math.pow(10, decCount)
}

export function fileNameAndExt(str) {
    var file = str.split('/').pop()
    return [
        file.substr(0, file.lastIndexOf('.')),
        file.substr(file.lastIndexOf('.') + 1, file.length),
    ]
}

export const trimLeadingSpaces = (str) => {
    return str.replace(/^\s\s*/, '');
}

export function waitForElementToDisplay(
    selector,
    callback,
    checkFrequencyInMs,
    timeoutInMs
) {
    var startTimeInMs = Date.now()
    ;(function loopSearch() {
        if (document.querySelector(selector) != null) {
            callback()
            return
        } else {
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                    return
                loopSearch()
            }, checkFrequencyInMs)
        }
    })()
}

export function convertToCurrency(str) {
    var n = Number.parseFloat(str)
    if (!str || isNaN(n) || n < 0) return null
    return n.toFixed(2)
}

export const getProducts = async (pages, queryUrl) => {
    // console.log('in getProducts')
    let result
    let products = []
    let morePagesAvailable = true
    let currentPage = 0

    if (!pages || !queryUrl) {
        return null
    }

    for (let i = 0; i < pages; i++) {
        // console.time('page loop')
        // console.log('currentPage', currentPage)
        currentPage++
        result = await axios(`${queryUrl}&page=${currentPage}`)

        products.push(result.data.products)

        morePagesAvailable = currentPage < pages

        // console.timeEnd('page loop')
    }

    if (products && products.length) {
        return {
            products: products.flat(1),
            data: result.data,
        }
    }
}

export function getEmbroideryImages() {
    const images = [
        {
            webName: 'Handwriting',
            slug: 'handwriting',
            fontName: "Bella's Hand",
            image: require('../../src/assets/images/fonts/bellas-hand_handwriting.png'),
        },
        {
            webName: 'Mama',
            slug: 'mama',
            fontName: 'Boucherie',
            image: require('../../src/assets/images/fonts/boucherie_calligraphy.png'),
        },
        {
            webName: 'Cursive',
            slug: 'cusrive',
            fontName: 'Castledown Cursive',
            image: require('../../src/assets/images/fonts/castledown-cursive_cursive.png'),
        },
        {
            webName: 'Calligraphy',
            slug: 'calligraphy',
            fontName: 'Boucherie',
            image: require('../../src/assets/images/fonts/boucherie_calligraphy.png'),
        },
        {
            webName: 'Typewriter',
            slug: 'typewriter',
            fontName: 'Garton',
            image: require('../../src/assets/images/fonts/garton_typewriter.png'),
        },
        {
            webName: 'Sans Serif',
            slug: 'sans-serif',
            fontName: 'Styrene',
            image: require('../../src/assets/images/fonts/styrene-b_sans-serif.png'),
        },
        {
            webName: 'Serif',
            slug: 'serif',
            fontName: 'Value Serif',
            image: require('../../src/assets/images/fonts/value-serif_serif.png'),
        },
        {
            webName: 'Monogram',
            slug: 'monogram',
            fontName: 'Round Monogram',
            image: require('../../src/assets/images/fonts/round-monogram_monogram.png'),
        },
        {
            webName: 'Athletic',
            slug: 'athletic',
            fontName: 'Hoboken High',
            image: require('../../src/assets/images/fonts/hoboken-serif_athletic.png'),
        },
        {
            webName: 'Script',
            slug: 'script',
            fontName: 'Learning Curve',
            image: require('../../src/assets/images/fonts/school-house_script.png'),
        },

        // {
        //         webName: 'Mama',
        //         slug: 'mama',
        //         fontName: 'Angelface',
        //         image: require('../../src/assets/images//mama.png'),
        //     },
        // {
        //     webName: 'Modern Cursive',
        //     slug: 'sweatpants',
        //     fontName: 'Sweatpants',
        //     image: require('../../src/assets/images/xb/sweatpants.png'),
        // },
        // {
        //     webName: 'Block Print',
        //     slug: 'din-alternate',
        //     fontName: 'DIN Alternate',
        //     image: require('../../src/assets/images/xb/din-alternate.png'),
        // },
        // {
        //     webName: 'Typewriter',
        //     slug: 'courier',
        //     fontName: 'Courier',
        //     image: require('../../src/assets/images/xb/courier.png'),
        // },
        // {
        //     webName: 'Diamond Monogram',
        //     slug: 'bebas-neue',
        //     fontName: 'Bebas Neue',
        //     image: require('../../src/assets/images/xb/bebas-neue.png'),
        // },
        // {
        //     webName: 'Handwriting',
        //     slug: 'sign-painter',
        //     fontName: 'Sign Painter',
        //     image: require('../../src/assets/images/xb/sign-painter.png'),
        // },
        // {
        //     webName: 'Varsity Letter',
        //     slug: 'varsity-team-bold',
        //     fontName: 'Varsity Font',
        //     image: require('../../src/assets/images/xb/varsity-team-bold.png'),
        // },
        // {
        //     webName: 'Script Bold Single',
        //     slug: 'script-bold-single',
        //     fontName: 'Angelface',
        //     image: require('../../src/assets/images/angelface.png'),
        // },
        // {
        //     webName: 'Serif',
        //     slug: 'agatho',
        //     fontName: 'Agatho',
        //     image: require('../../src/assets/images/xb/agatho.png'),
        // },
        // {
        //     webName: 'Classic Cursive',
        //     slug: 'angelface',
        //     fontName: 'Angelface',
        //     image: require('../../src/assets/images/xb/angelface.png'),
        // },
    ]

    return images
}

export const PRODUCT_TITLES = [
    'Adult Embroidered Crewneck Sweatshirt',
    'Adult Hammerhead Shark Printed Tee',
    'Adult Organic Everyday Twill Shorts',
    'Adult Organic Life of the Party Dress',
    'Adult Short Sleeve Slub Jersey Printed Tee',
    'Matching Family Adult One-Piece Pajamas',
    'Matching Family Adult Two-Piece Pajamas',
    'TRUNK SALE - Adult Embroidered Crewneck Sweatshirt',
    'TRUNK SALE - Matching Family Adult One-Piece Pajamas',
    'TRUNK SALE - Matching Family Adult Two-Piece Pajamas',
    "Double Ruffle Let's Dance Dress Bundle",
    'Hooded Sweatshirt Dress Bundle',
    "Let's Dance Dress Bundle",
    'Long Sleeve Peplum Top Bundle',
    'Oxford Sport Short Bundle',
    'Oxford Sweat Short Bundle',
    'Peplum Tank Bundle',
    "Short Sleeve Let's Dance Dress Bundle",
    'The BASIC Long Sleeve V-Neck Tee Bundle',
    'The Bodysuit + BASIC Groove Pants Bundle',
]

export const PRODUCT_DUPES = [
    {
        a: 'adult-embroidered-crewneck-sweatshirt',
        b: 'embroidered-crewneck-sweatshirt',
    },
    { a: 'adult-hammerhead-printed-tee', b: 'hammerhead-printed-tee' },
    {
        a: 'adult-organic-everyday-twill-shorts',
        b: 'organic-everyday-twill-shorts',
    },
    {
        a: 'adult-organic-life-of-the-party-dress',
        b: 'organic-life-of-the-party-dress',
    },
    {
        a: 'adult-short-sleeve-slub-jersey-printed-tee',
        b: 'short-sleeve-slub-jersey-printed-tee',
    },
    { a: 'matching-family-adult-one-piece-pajamas', b: 'one-piece-pajamas' },
    { a: 'matching-family-adult-two-piece-pajamas', b: 'two-piece-pajamas' },
    {
        a: 'TRUNK-SALE-adult-embroidered-crewneck-sweatshirt',
        b: 'TRUNK-SALE-embroidered-crewneck-sweatshirt',
    },
    {
        a: 'TRUNK-SALE-matching-family-adult-one-piece-pajamas',
        b: 'TRUNK-SALE-one-piece-pajamas',
    },
    {
        a: 'TRUNK-SALE-matching-family-adult-two-piece-pajamas',
        b: 'TRUNK-SALE-two-piece-pajamas',
    },
    {
        a: 'double-ruffle-lets-dance-dress-bundle',
        b: 'double-ruffle-lets-dance-dress',
    },
    { a: 'hooded-sweatshirt-dress-bundle', b: 'hooded-sweatshirt-dress' },
    { a: 'lets-dance-dress-bundle', b: 'lets-dance-dress' },
    { a: 'long-sleeve-peplum-top-bundle', b: 'long-sleeve-peplum-top' },
    { a: 'oxford-sport-short-bundle', b: 'oxford-sport-short' },
    { a: 'oxford-sweat-short-bundle', b: 'oxford-sweat-short' },
    { a: 'peplum-tank-bundle', b: 'peplum-tank' },
    {
        a: 'short-sleeve-lets-dance-dress-bundle',
        b: 'short-sleeve-lets-dance-dress',
    },
    {
        a: 'the-basic-long-sleeve-v-neck-tee-bundle',
        b: 'the-basic-long-sleeve-v-neck-tee',
    },
    { a: 'the-bodysuit-basic-groove-pants-bundle', b: 'basic-groove-pants' },
]

export const SIZES = [
    'Premie',
    'preemie',
    'newborn',
    '0–2Y',
    '0-2Y',
    '0-3m',
    '0–3m',
    '3-6m',
    '3–6m',
    '0-6m',
    '0–6m',
    '6-9m',
    '6–9m',
    '0-12m',
    '0–12m',
    '9-12m',
    '9–12m',
    '6-12m',
    '6–12m',
    '12-18m',
    '12–18m',
    '12-24m',
    '12–24m',
    '18-24m',
    '18–24m',
    '1T',
    '2T',
    '2/3T',
    '2–3T',
    '2-3T',
    '3T',
    '4T',
    '4/5T',
    '4/6Y',
    '5T',
    '6T',
    '6/7',
    '6/8',
    '7/8Y',
    '7–12Y',
    '7-12Y',
    '8',
    '9/10Y',
    '10',
    'XS',
    'XS/S',
    'S',
    'M',
    'M/L',
    'L',
    'L/XL',
    'XL',
    'XXL',
    'Big Kid',
    'Little Kid',
    'Adult',
]

export const PATTERNS = [
    'Spring Squad',
    'Wheelie Cute',
    'Sunflower Field',
    'Hammerhead Shark',
    'Black + White Mod Stripe',
]

export const getCookie = (cname) => {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}
